import { createReducer } from 'typesafe-actions';

import {
  TOnboardingUserState,
  TOnboardingUserAction,
  OnboardingUserActionTypes,
} from '@/store/types/onboarding-user.types';

const initialState: TOnboardingUserState = {
  completed: {
    state: {
      elements: [],
      cursor: { current: undefined, prev: undefined, next: undefined },
    },
  },
  incompleted: {
    state: {
      elements: [],
      cursor: { current: undefined, prev: undefined, next: undefined },
    },
  },
};

export const onboardingUserReducer = createReducer<TOnboardingUserState, TOnboardingUserAction>(initialState)
  .handleType(OnboardingUserActionTypes.FETCH_ONBOARDING_USERS, (state, action) => ({
    ...state,
    [action.onboardingUserType]: {
      ...state[action.onboardingUserType],
      isLoading: true,
      error: undefined,
    },
  }))

  .handleType(OnboardingUserActionTypes.FETCH_ONBOARDING_USERS_SUCCESS, (state, action) => ({
    ...state,
    [action.onboardingUserType]: {
      ...state[action.onboardingUserType],
      state: {
        elements: action.isClear
          ? action.paginateOnboardingUsers?.elements || []
          : [
              ...(state[action.onboardingUserType].state?.elements || []),
              ...(action.paginateOnboardingUsers?.elements || []),
            ],
        cursor: action.paginateOnboardingUsers?.cursor || state[action.onboardingUserType].state?.cursor,
      },
      isLoading: false,
      error: undefined,
    },
  }))

  .handleType(OnboardingUserActionTypes.FETCH_ONBOARDING_USERS_FAIL, (state, action) => ({
    ...state,
    [action.onboardingUserType]: {
      ...state[action.onboardingUserType],
      isLoading: false,
      error: action.error,
    },
  }));
